import { render, staticRenderFns } from "./GroupCategory.vue?vue&type=template&id=68cb0349&"
import script from "./GroupCategory.vue?vue&type=script&lang=js&"
export * from "./GroupCategory.vue?vue&type=script&lang=js&"
import style0 from "./GroupCategory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports